export type ExperimentEntry = [string, App.OptimizelyExperimentDetails]
export type FeatureFlagEntry = [string, boolean]

/**
 * Formats the experiment title
 * @returns The title by replacing '_' with spaces and capitalising each word e.g. 'multi_item_cart' to 'Multi Item Cart'
 */
export function formatOptimizelyTitle(experimentId: string): string {
  const experimentIdList = experimentId.split('_')
  if (experimentIdList.length === 0) {
    return ''
  }
  return experimentIdList
    .filter(word => word.length > 0)
    .map(word => word[0].toUpperCase() + word.slice(1))
    .join(' ')
}

export function filterOptimizelyEntry(query: string) {
  return ([itemId]: ExperimentEntry | FeatureFlagEntry) => {
    const itemName = formatOptimizelyTitle(itemId)
    return (itemId.toLowerCase().includes(query.toLowerCase()) || itemName.toLowerCase().includes(query.toLowerCase()))
  }
}

export function getExperimentCohortKeys(experiment: App.OptimizelyExperimentDetails): Array<string> {
  const variationMap = experiment.variation ?? {}
  const cohortKeys = Object.keys(variationMap).sort((a, b) => a.localeCompare(b))

  if (cohortKeys.length === 0) {
    return ['off', 'on']
  }

  return ['off', ...cohortKeys]
}

export function getSelectedCohort(
  experiment: App.OptimizelyExperimentDetails,
  cohortKeys: Array<string>,
): string {
  if (!experiment.enabled) {
    return 'off'
  }

  if (cohortKeys.includes(experiment.variationKey)) {
    return experiment.variationKey
  }

  if (cohortKeys.includes('on')) {
    return 'on'
  }

  return cohortKeys[0] ?? experiment.variationKey
}
